// Shared labels/defaults only. The server independently enforces each view's scope.
const personal = { value: 'mine', label: 'My reminders', hint: 'Reminders added by me' };
const clients = { value: 'my-clients', label: 'My clients', hint: 'Reminders for cases and applications assigned to me' };
const regional = { value: 'region', label: "My region’s clients", hint: 'Reminders for cases and applications within my regional remit' };
const all = { value: 'all-clients', label: 'All clients', hint: 'Reminders for all cases and applications' };

function getReminderViews(role) {
  if (role === 'ISET Coordinator') return [clients];
  if (role === 'Regional Manager') return [personal, clients, regional];
  if (role === 'NWAC Administrator') return [personal, clients, all];
  if (role === 'System Administrator') return [all, personal, clients];
  return [];
}

module.exports = { getReminderViews };
